module.exports = __webpack_public_path__ + "img/logo.ed3dc9b7.png";